<div class="search-panel-container">
  <form name="searchPanelForm" id="searchPanelForm" #searchPanelForm="ngForm">

    <div class="cci-search-form-group">
      <h3>Search</h3>
    </div>

    <div class="cci-search-form-group">
      Calendars:
        <label class="cci-search-input-label">
          <textarea class="cci-input cci-search-input cci-search-input-textarea" type="text" name="calendars" [(ngModel)]="calendars" #calendarsValidation="ngModel"
                    placeholder="example@racap.com,..." required>
            <span *ngIf="calendarsValidation.errors && showErrors" class="error">
              <span [hidden]="!calendarsValidation.errors.required">Required</span>
            </span>
          </textarea>
        </label>
      <span *ngIf="calendarsValidation.errors && showErrors" class="error">
        <span [hidden]="!calendarsValidation.errors.required">Required</span>
      </span>
    </div>

    <div class="cci-search-form-group d-flex">
      Date Range
      <div>
        Start: <input class="cci-input cci-search-input" type="date" name="start" [(ngModel)]="start" #startValidation="ngModel" required>
        <span *ngIf="startValidation.errors && showErrors" class="error">
        <span [hidden]="!startValidation.errors.required">Required</span>
      </span>
      </div>

      <div>
        End: <input class="cci-input cci-search-input" type="date" name="end" [(ngModel)]="end" #endValidation="ngModel" required>
        <span *ngIf="endValidation.errors && showErrors" class="error">
        <span [hidden]="!endValidation.errors.required">Required</span>
      </span>
      </div>

      <button (click)="setToCurrentDate()">
        Set to today
      </button>
      <button (click)="setToTomorrow()">
        Set to tomorrow
      </button>
    </div>

    <div class="cci-search-form-group">
      Filters
      <div>
        Must include <strong>ALL</strong> of:
        <input class="cci-input cci-search-input" type="text" name="allTerms" [(ngModel)]="allTerms" placeholder="meeting,...">
      </div>
      <div>
        Must include <strong>ANY</strong> of:
        <input class="cci-input cci-search-input" type="text" name="anyTerms" [(ngModel)]="anyTerms" placeholder="meeting,...">
      </div>
      <div>
        Must <strong>NOT</strong> include:
        <input class="cci-input cci-search-input" type="text" name="noTerms" [(ngModel)]="noTerms" placeholder="meeting,...">
      </div>
      <div>
        Only show <strong>EXTERNAL</strong> companies:
        <input class="cci-input cci-search-input" type="checkbox" name="externalOnly" [(ngModel)]="externalOnly">
      </div>
      <div>
        Filter on <strong>Pub, Priv, Conf, Govt or Expert</strong> only:
        <input class="cci-input cci-search-input" type="checkbox" name="pubPrivConfGovtOnly" [(ngModel)]="pubPrivConfGovtOnly">
      </div>
    </div>

    <div class="cci-search-form-group">
      <button (click)="showErrors = true; searchPanelForm.valid && search(true)">Search events</button>
      <button (click)="showErrors = true; searchPanelForm.valid && saveCurrentQuery()">+ Save this query</button>
    </div>

  </form>
</div>
